<script>
export default {
  props: ["data", "meta"],
};
</script>
<template>
  <div class="service-grid-item service-grid-item--style2">
    <div class="service-grid-item__image">
      <div class="service-grid-item__image-wrapper">
        <router-link :to="`jurusan-detail${meta.preview}id=${data.url}`">
          <img :src="data.image" class="img-fluid" alt="thumbnail" />
        </router-link>
      </div>
    </div>
    <div class="service-grid-item__content">
      <h3 class="title">
        <router-link :to="`jurusan-detail${meta.preview}id=${data.url}`">
          {{ data.title }}
        </router-link>
      </h3>
      <!--
            <p class="subtitle">{{ data.body }}</p>
            -->
      <p class="subtitle">
        {{ data.body.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 100) }}
      </p>

      <router-link
        :to="`jurusan-detail${meta.preview}id=${data.url}`"
        class="see-more-link"
        >SELENGKAPNYA</router-link
      >
    </div>
  </div>
</template>

<style lang="scss"></style>
